
<template>
  <div class="page-actions">
    <template v-for="action in headerActions">
      <router-link class="page-action" :to="action.routerLinkTo" v-if="action.routerLinkTo"><span v-html="action.html" v-if="action.html"></span v-if="action.text">{{action.text}}</span></router-link>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'partials-actions',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['headerActions'])
  },
  methods: {
    getItemText: function (crumb) {
      if (typeof crumb.meta.breadcrumb === 'function') {
        return crumb.meta.breadcrumb.call(crumb, this.$route)
      }
      return crumb.meta.breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/foundation-import';

  .page-actions {
    .page-action {
      margin-right: $global-margin;
      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Actions.vue?1abf8e6e